import { z } from "zod";
import { MUSICAL_KEY_LIST } from "../music";
import { SCROLL_SPEED_MAX, SCROLL_SPEED_MIN } from "../perform-stage";
import { SONG_STATUS_LIST } from "../song-status";

const songLinksSchema = z
  .object({
    youtube: z.string().optional(),
    spotify: z.string().optional(),
    deezer: z.string().optional(),
  })
  .optional();

const songAttachmentSchema = z.object({
  id: z.string(),
  name: z.string(),
  type: z.string(),
  size: z.number(),
  part: z.string().optional(),
});

export const songSchema = z.object({
  id: z.string(),
  title: z.string().min(1, "Title is required"),
  artist: z.string().optional(),
  key: z.enum(MUSICAL_KEY_LIST as [string, ...string[]]).optional(),
  bpm: z.number().int().positive().optional(),
  duration: z.number().int().positive().optional(),
  transposition: z.number().int().min(-11).max(11).optional(),
  scrollSpeed: z.number().int().min(SCROLL_SPEED_MIN).max(SCROLL_SPEED_MAX).optional(),
  status: z.enum(SONG_STATUS_LIST).optional(),
  tags: z.array(z.string()),
  notes: z.string().optional(),
  techNotes: z.string().optional(),
  links: songLinksSchema,
  attachments: z.array(songAttachmentSchema).optional(),
  patches: z.record(z.string(), z.string()).optional(),
  content: z.string(),
  createdAt: z.number(),
  updatedAt: z.number(),
});

export const songFormSchema = songSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
});

export type SongFormValues = z.infer<typeof songFormSchema>;
